module.exports = __webpack_public_path__ + "static/img/home_fsps.8254cb9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home_fsps.png
// module id = luFc
// module chunks = 0